<!-- Ported from the Polaris kit: src/product/components/DurationInput.vue.
     Classes translated to Tailwind 3 by rebranding_frontend/port-kit-component.mjs;
     strings moved to i18n by hand. Change the design in the kit first.
     Hand changes (phase 9.3): the ": amount"/": unit" names and the unit words go through i18n
     (SETTINGS_PIECES.DURATION); `units` may be `{ value, label }` (OptionSelect takes both). -->
<script setup>
// An amount of time: a number and its unit (minutes, hours, days). Both are named, so it reads as one thing to a screen reader.
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import {
  NumberField,
  NumberFieldContent,
  NumberFieldDecrement,
  NumberFieldIncrement,
  NumberFieldInput,
} from '../ui/number-field';
import OptionSelect from './OptionSelect.vue';

// { value, unit }
const props = defineProps({
  label: { type: String, required: true },
  units: { type: Array, default: null },
  disabled: Boolean,
});
const model = defineModel({
  type: Object,
  default: () => ({ value: 1, unit: 'Hours' }),
});
const { t } = useI18n();
const unitOptions = computed(
  () =>
    props.units ?? [
      { value: 'Minutes', label: t('SETTINGS_PIECES.DURATION.MINUTES') },
      { value: 'Hours', label: t('SETTINGS_PIECES.DURATION.HOURS') },
      { value: 'Days', label: t('SETTINGS_PIECES.DURATION.DAYS') },
    ]
);
const set = patch => {
  model.value = { ...model.value, ...patch };
};
</script>

<template>
  <div
    class="flex items-center gap-2"
    role="group"
    :aria-label="label"
    data-duration
  >
    <NumberField
      :model-value="model.value"
      :min="1"
      :disabled="disabled"
      class="w-32"
      @update:model-value="value => set({ value })"
    >
      <NumberFieldContent>
        <NumberFieldDecrement />
        <NumberFieldInput
          :aria-label="t('SETTINGS_PIECES.DURATION.AMOUNT', { label })"
        />
        <NumberFieldIncrement />
      </NumberFieldContent>
    </NumberField>
    <div class="w-28">
      <OptionSelect
        :model-value="model.unit"
        :options="unitOptions"
        :aria-label="t('SETTINGS_PIECES.DURATION.UNIT', { label })"
        :disabled="disabled"
        @update:model-value="unit => set({ unit })"
      />
    </div>
  </div>
</template>
